import { storageGet } from '../libs/localStorage';

export default async (productId) => {
  const comparesListObject = storageGet('compare');
  const comparesIds = [];
  if (comparesListObject) {
    const comparesIdsList = Object.keys(comparesListObject);
    if (comparesIdsList.includes(`${productId}`)) return false;

    comparesIds.push(...comparesIdsList);
  }

  comparesIds.push(`${productId}`);

  const queryString = new URLSearchParams({
    itemsIds: JSON.stringify(comparesIds),
  });

  const response = await fetch(`/local/ajax/compare/updateItems.php?${queryString}`, {
    method: 'POST',
  });
  if (response.ok) {
    const result = await response.json();
    if (Array.isArray(result) && !result.length) {
      const modalWrapper = document.querySelector('[data-list-type="jsCompareProduct"]');
      modalWrapper.classList.remove('_with-popup--active');

      const modal = modalWrapper.querySelector('.buttons-bottom-header__item-popup');
      modal.style.display = 'none';
      setTimeout(() => {
        modal.style.display = 'block';
      }, 550);
    }
    window.updateComparesItems(result);
  }

  return false;
};
